import { AuditSearchDto, AuditViewDto } from '../../../../service/dto';
import { Component, Input } from '@angular/core';
import { AgentDto, AuditSessionDto, ResultListDto } from '../../../../service/dto';
import { HttpAuditService } from '../../../../service/http-audit.service';
import { OnTableChange, TableColumn } from '../../../../components/table/table.component';
import { finalize } from 'rxjs';

@Component({
	selector: 'app-agent-audit-searches',
	standalone: false,
	templateUrl: './agent-audit-searches.component.html',
	styleUrl: './agent-audit-searches.component.scss'
})
export class AgentAuditSearchesComponent {
	_agent!: AgentDto;
	results!: ResultListDto<AuditSearchDto>;
	loading = false;
	columnRef: TableColumn[] = [
		{ "title": "Date", "cellRef": "date", exportValue: item => `${item.date}` },
		{ "title": "Type", "property": "recordType" },
		{ "title": "Description", "property": "recordLabel" },
		{ "title": "Records Returned", "property": "recordCount" },
		{
			"title": "Filters", "cellRef": "filters", exportValue: item => {
				let out = '';
				for (let filter of item.filters ?? []) {
					out += `${filter.filterName}: ${filter.filterValue}, `;
				}
				return out;
			}
		}
	];

	constructor(private service: HttpAuditService) {

	}

	@Input('agent')
	set agent(input: AgentDto) {
		this._agent = input;
		this.loading = true;
		this.service.getAgentsSearchHistory(this._agent.id, 0, 50)
			.pipe(finalize(() => this.loading = false))
			.subscribe(results => {
				this.results = results;
			})
	}

	get agent(): AgentDto {
		return this._agent;
	}


	trackByHashCode(index: number, item: AuditSessionDto): any {
		return item.hashCode;
	}

	doFetchResults(input: OnTableChange) {
		this.loading = true;
		this.service.getAgentsSearchHistory(this._agent.id, input.pageIndex, input.pageSize)
			.pipe(finalize(() => {
				this.loading = false;
			}))
			.subscribe(result => {
				this.results = result;
			});
	}
}

